/* Display only: never sets a price, discount, variant or cart quantity. */
(() => {
  'use strict';
  const form = document.querySelector('#mistmove-product-form');
  const comparison = document.querySelector('#set-compare-price');
  const picker = document.querySelector('#pack-variant');
  if (!form || !comparison || !picker) return;
  function render() {
    const {variantId, priceCents, compareCents} = comparison.dataset;
    const price = Number(priceCents);
    const compare = Number(compareCents);
    const valid = /^\d+$/.test(priceCents || '') && /^\d+$/.test(compareCents || '') && Number.isSafeInteger(price) && Number.isSafeInteger(compare) && compare > price;
    comparison.hidden = !(valid && picker.value === variantId && document.querySelector('[name=set]:checked')?.value === '1');
  }
  // pricing.js registers radio handlers first and updates the real variant picker.
  form.addEventListener('change', render);
  render();
})();
